import React, { useEffect } from 'react';
import styles from './Tabs.scss';

export interface ITabsProps {
    className?: string;
    children: React.ReactNodeArray;
    activeTab: string;
}

const Tabs: React.FC<React.PropsWithChildren<ITabsProps>> = ({ activeTab, className = '', children = null }) => {
    const refParent = React.useRef<HTMLUListElement>(null);
    const refActiveTab = React.createRef<HTMLLIElement>();
    const refIndicator = React.createRef<HTMLLIElement>();

    useEffect(() => {
        const rectParent = refParent?.current?.getBoundingClientRect();
        const rect = refActiveTab?.current?.getBoundingClientRect();
        if (refIndicator?.current) {
            refIndicator.current.style.cssText = `left: ${rect?.left - rectParent?.left}px;width: ${rect?.width}px;top: auto;bottom:0`;
        }
    }, [children]);

    return (
        <ul ref={refParent} className={styles.tabs + ' ' + className}>
            {React.Children.map(children, (child: React.ReactElement) =>
                React.cloneElement(child, { ref: refActiveTab, _active: activeTab === child.props.name })
            )}
            <li ref={refIndicator} className={styles.indicator}></li>
        </ul>
    );
};

export default Tabs;
